<template>
  <ButtonSquare
    :title="$t('general__view__droneview')"
    :imgSource="require('@/assets/icon-drone.svg')"
    size="large"
    :activeState="activeState"
    :hoverButtons="hoverButtons"
    :activeHoverButtonValue="currentDroneviewLinkId"
    @mouseover="$emit('DroneButtonHovered')"
    @clicked="toggle"
    @onHoverButtonClick="toggle"
  />
</template>

<script>
import ButtonSquare from '@/components/general/buttons/ButtonSquare/ButtonSquare.vue'
import { mapMutations, mapState } from 'vuex'
import { MAPVIEW_PREFIX } from '@/store/module-prefixes'
import { SET_CURRENT_DRONEVIEW_LINK_ID } from '@/store/mutation-types'
import { setViewToDroneview } from '@/utils/views'
export default {
  name: 'DroneButton',
  components: {
    ButtonSquare
  },
  emits: ['DroneButtonHovered'],
  computed: {
    ...mapState({
      currentDroneviewLinkId: (state) => state.currentDroneviewLinkId
    }),
    ...mapState(MAPVIEW_PREFIX, {
      selectedRealEstate: (state) => state.selectedRealEstate
    }),
    activeState() {
      if (this.hoverButtons && this.hoverButtons.length) return 'inactive'
      else return 'deactivated'
    },
    hoverButtons() {
      const hoverButtons = []
      if (this.selectedRealEstate == null) return hoverButtons
      if (!this.selectedRealEstate.droneviewLinks || !this.selectedRealEstate.droneviewLinks.length)
        return hoverButtons
      this.selectedRealEstate.droneviewLinks.forEach((link, index) => {
        hoverButtons.push({ title: link.title, emit: index.toString() })
      })
      return hoverButtons
    }
  },
  methods: {
    toggle(id) {
      if (this.activeState === 'deactivated') return null
      if (this.hoverButtons.length && id) this.setCurrentDroneviewLinkId(this.hoverButtons[id].emit)
      setViewToDroneview()
    },
    ...mapMutations({
      setCurrentDroneviewLinkId: SET_CURRENT_DRONEVIEW_LINK_ID
    })
  }
}
</script>

<style lang="scss" scoped></style>
